<app-kpi-widget 
  [title]="'driverDashboard.widgets.driversEnRoute' | transloco"
  [isLoading]="isLoading"
  [icon]="'ph-road-horizon'"
  [totalValue]="value"
  [valueFormatter]="formatValue"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  (clicked)="openDriverEnRouteModal()"
  [widgetDisabled]="false"
  [dropdownEnabled]="false"
  [isImageIcon]="false"
  [hasFooter]="false"
  [percentageDifferenceEnabled]="false"
  [hasValueOnly]="true"
  [widgetDisabled]="false">
</app-kpi-widget>